import { Navigate } from "react-router-dom";
// import AssignedVc from "../../components/endUser/AssignedVc";
// import Endpoints from "../../components/endUser/Endpoints";
// import MyConnections from "../../components/endUser/MyConnections";
// import Policy from "../../components/endUser/Policy";
// import Request from "../../components/endUser/Request";
// import EndpointUsers from "../../components/privilegedAccessManagement/endpointsUsers/EndpointUsers";
import Connection from "../../pages/enduser/connections";
import UserDashboard from "../../pages/enduser/dashboard";
import Endpoints from "../../pages/enduser/endpoints";
import AgentLogs from "../../pages/enduser/endpoints/AgentLogs";
import EndpointDetails from "../../pages/enduser/endpoints/details/EndpointDetails";
import PolicyPage from "../../pages/enduser/policy/policy";
import ProfilePage from "../../pages/enduser/profile";

// const endUserRouter = [
//     { path: "endpoints", element: <Endpoints /> },
//     { path: "endpointUsers", element: <EndpointUsers /> },
//     { path: "connections", element: <MyConnections /> },
//     { path: "assignedVcs", element: <AssignedVc /> },
//     { path: "policies", element: <Policy /> },
//     { path: "request", element: <Request /> }
// ];


const endUserRouter = [
    {
        path: "dashboard",
        element: <UserDashboard />,
    },
    {
        path: "endpoint",
        children: [
            { path: "", element: <Endpoints /> },
            { path: "endpointDetails", element: <EndpointDetails /> },
            { path: 'agentLogs', element: <AgentLogs /> },
        ],
    },
    {
        path: "connections",
        children: [
            { path: "", element: <Connection /> },
            { path: ":publicIpAddress", element: <Connection /> },
        ],
    },
    {
        path: "policies",
        element: <PolicyPage />,
    },
    {
        // My access is gone: operators connect from Endpoints → Connect.
        path: "myAccess",
        element: <Navigate to="/tenant/users/dashboard" replace />,
    },
    {
        path: "profile",
        element: <ProfilePage />,
    },
];

export default endUserRouter;
